export default __webpack_public_path__ + "static/media/go-lightning.c114a52f.png";